import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FormGroup, ReactiveFormsModule} from '@angular/forms';
import {NgClass} from '@angular/common';
import {TooltipModule} from '@syncfusion/ej2-angular-popups';

@Component({
  selector: 'app-form-input-content',
  imports: [
    ReactiveFormsModule,
    NgClass,
    TooltipModule
  ],
  templateUrl: './form-input-content.component.html'
})
export class FormInputContentComponent {
  @Input() public type: 'text' | 'search' | 'password' | 'number' = 'text';
  @Input() public placeholder: string = '';
  @Input() public fCN: string = '';
  @Input() public fG: FormGroup = new FormGroup({});
  @Input() public label: string = '';
  @Input() public errorText: string = '';
  @Input() public iconFront: string = '';
  @Input() public iconBack: string = '';
  @Input() public iconClickType: 'none' | 'front' | 'back' | 'both' = 'none';
  @Input() public iconFrontTooltip: string = '';
  @Input() public iconBackTooltip: string = '';
  @Input() public style: 'inline' | 'block' | 'headless' = 'headless';
  @Input() public disabled: boolean = false;
  @Input() public cssClass: string = '';
  @Input() public hasErrorField: boolean = true;
  @Input() public wrapperClass: string = '';
  @Input() public autocomplete: string | null = null;
  @Input() public inputName: string | null = null;
  @Input() public layouttype: 'default' | 'composite' = 'default';

  @Output() public blurred: EventEmitter<void> = new EventEmitter<void>();
  @Output() public returnKeyPress: EventEmitter<void> = new EventEmitter<void>();
  @Output() public iconFrontClick: EventEmitter<void> = new EventEmitter<void>();
  @Output() public iconBackClick: EventEmitter<void> = new EventEmitter<void>();

  public canClickFrontIcon(): boolean {
    return this.iconClickType === 'front' || this.iconClickType === 'both';
  }

  public canClickBackIcon(): boolean {
    return this.iconClickType === 'back' || this.iconClickType === 'both';
  }

  public onReturnKeyPress(): void {
    this.returnKeyPress.emit();
  }

  public onIconFrontClicked(): void {
    if (this.canClickFrontIcon()) {
      this.iconFrontClick.emit();
    }
  }

  public onIconBackClicked(): void {
    if (this.type === 'search') {
      this.fG.controls[this.fCN].setValue('');
    }

    if (this.canClickBackIcon()) {
      this.iconBackClick.emit();
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public onInput(event: Event): void {
    // Keep hook if needed later.
  }

  public onBlur(): void {
    if (!this.disabled) {
      this.blurred.emit();
    }
  }
}